import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../services';
import { apps } from '../../constants';
import { AppStateHolder } from '../../shared';
import { smartButtonIcons } from './icons';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { PrimeTemplate, Footer } from 'primeng/api';
import { DragDropModule } from 'primeng/dragdrop';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { Button } from 'primeng/button';
import { ColorPickerModule } from 'primeng/colorpicker';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TranslateModule } from '@ngx-translate/core';
import { DebugLoggerService } from '../../services/debug-logger.service';

@Component({
  selector: 'smart-box-v2',
  templateUrl: './smart-box-v2.component.html',
  styleUrls: ['./smart-box-v2.component.scss'],
  standalone: true,
  imports: [TooltipModule, DialogModule, PrimeTemplate, DragDropModule, DividerModule, FormsModule, InputTextModule, DropdownModule, Button, ColorPickerModule, Footer, OverlayPanelModule, TranslateModule]
})
export class SmartBoxV2Component implements OnInit {
  private _router = inject(Router);
  private _dashboardService = inject(DashboardService);
  stateHolder = inject(AppStateHolder);
  private _debugLogger = inject(DebugLoggerService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  @Input() apps: any;
  @Input() selectedDashboardButtons: string;

  @Input() editMode: boolean;
  @Input() idx: number;
  // @Input() baseUrl: string;
  // @Input() userModel: any;

  smartButtons: any;
  selectedSmartButtons: any;

  showEditModal: boolean = false;
  showButtonBin: boolean = false;

  draggedButton: any;
  draggedMovedButton: any;
  selectedButtonToEdit: any;

  dialogRequestTypes: any;

  icons: any = smartButtonIcons;
  selectedIcon: any = {
    iconClass: 'sub_icon primeNG pi pi-plus-circle',
    name: 'Nuovo'
  };

  @Output() dashboardParams: EventEmitter<any> = new EventEmitter();
  @Output() disableEditMode: EventEmitter<any> = new EventEmitter();
  @Output() boxIndex: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this._debugLogger.logLifecycle('SmartBox', 'ngOnInit');
    this.smartButtons = []
    this.selectedSmartButtons = [];
    this.icons.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

    this.mapSmartButtons();
    this.mapWidgetParams();
    this.mapSmartButtonView()

    if (this.editMode)
      this.getDialogRequestTypologies();
  }


  mapSmartButtons() {
    // check if apps is defined
    if (!this.apps)
      return;

    this.smartButtons = this.apps.map(app => {
      if (!app.cssParams) return new SmartButtonModel(app);
      switch (app.cssParams.appClass) {
        case 'app-orange':
          app.buttonClass = "tile tile-sm tile-orange";
          break;
        case 'app-blue':
          app.buttonClass = "tile tile-sm tile-blue";
          break;
        case 'app-red':
          app.buttonClass = "tile tile-sm tile-red";
          break;
        case 'app-green':
          app.buttonClass = "tile tile-sm tile-green";
          break;
        case 'app-purple':
          app.buttonClass = "tile tile-sm tile-purple";
          break;
        case 'app-grey':
          app.buttonClass = "tile tile-sm tile-grey";
          break;
        case 'app-yellow':
          app.buttonClass = "tile tile-sm tile-yellow";
          break;
        default:
          app.buttonClass = "";
      }

      if (!app.iConClass)
        app.buttonIcon = "sub_icon " + app.cssParams.menuIconClass;

      return new SmartButtonModel(app);
    });

    this.smartButtons.push(this.getCustomDialogButton());
    this.smartButtons.push(this.getCustomLinkButton());
  }


  mapSmartButtonView() {
    this.smartButtons = this.smartButtons.filter(b => {
      return !this.selectedSmartButtons.some(selectedSmartButton =>
        !b.custom && b.name === selectedSmartButton.name && b.refAppId === selectedSmartButton.refAppId
      );
    });
  }

  mapWidgetParams() {
    this.selectedSmartButtons = this.selectedDashboardButtons ?
      JSON.parse(this.selectedDashboardButtons).map(sb => new SmartButtonModel(sb))
      : [];
  }

  selectIcon(icon: any) {
    // check if icon is defined
    if (!icon)
      return;

    this.selectedButtonToEdit.buttonIcon = icon.iconClass;
    this.selectedIcon = icon;
  }

  navigateTo(smartButton: any) {
    this._debugLogger.logAction('SmartBox', 'navigateTo', { name: smartButton?.name, url: smartButton?.url, refAppId: smartButton?.refAppId });
    // check if smartButton is defined
    if (!smartButton)
      return;

    // check if navigateToAttendanceUrl is true
    if (this.navigateToAttendanceUrl(smartButton.url))
      return;

    if (this.navigateToRefoundedCosts(smartButton.url))
      return;

    // handle custom smartButtons
    if (smartButton.custom) {
      if (smartButton.name === 'Custom Dialog') {
        let url = this.stateHolder.getAppUrl(apps.dialog);
        this.stateHolder.setAppNavbarClass(apps.dialog);
        let link = ['app', `${url}/create/${smartButton.params.idRequestTypology}`];
        this._router.navigate(link);
        return;
      }
      if (smartButton.name === 'Custom link') {
        smartButton.url = smartButton.url.startsWith('http') ? smartButton.url : `https://${smartButton.url}`;
        window.open(smartButton.url, "_blank");
        return;
      }
    }

    // handle smartButtons with params and URL
    if (smartButton.params && smartButton.params.idRequestTypology) {
      let url = this.stateHolder.getAppUrl(apps.dialog);
      this.stateHolder.setAppNavbarClass(apps.dialog);
      let link = ['app', `${url}/create/${smartButton.params.idRequestTypology}`];
      this._router.navigate(link);
      return;
    }

    if (smartButton.url) {
      smartButton.url = smartButton.url.startsWith('http') ? smartButton.url : `https://${smartButton.url}`;
      window.open(smartButton.url, "_blank");
      return;
    }

    // handle smartButtons with refAppId
    if (smartButton.refAppId) {
      this.stateHolder.setAppNavbarClass(smartButton.refAppId);
      this._router.navigate(['app', smartButton.refAppId]);
    }
  }

  async getDialogRequestTypologies() {
    try {
      this.dialogRequestTypes = await this._dashboardService.getDialogRequestTypologyes().toPromise();
      this._debugLogger.logAction('SmartBox', 'dialogRequestTypes loaded', { count: this.dialogRequestTypes?.length });
    } catch (error) {
      console.error(error);
    }
  }

  navigateToAttendanceUrl(widgetUrl: any): boolean {
    console.log('navigateToAttendanceUrl', widgetUrl);
    // Define the base URL
    let url = 'https://attendancesheet.neworg.net/';

    // Check if the widget URL is present and not empty
    if (!widgetUrl || widgetUrl.trim().length === 0)
      return false;

    // Define an object that maps the conditions to the URLs and class names
    const routeMap = {
      'clocking/attendancestates': {
        link: ['app', `${url}/clocking/attendancestates`],
        class: apps.attendanceSheet
      },
      'emergencypresencestate': {
        link: ['app', `${url}/emergencypresencestate`],
        class: 'setHREmergencyNavbarClass'
      },
      'causalRequest/crpresencestates': {
        link: ['app', `${url}/causalRequest/crpresencestates`],
        class: apps.causalRequest
      },
      'causalRequest/managegantt': {
        link: ['app', `${url}/causalRequest/managegantt`],
        class: apps.causalRequest
      }
    };

    const route = routeMap[widgetUrl];
    console.log('route', route);
    // Check if a route is defined for the widget URL
    if (!route) return false;

    // Set the class name and navigate to the URL
    this.stateHolder.setAppNavbarClass(route.class);

    this._router.navigate(route.link);
    return true;
  }

  navigateToRefoundedCosts(widgetUrl: any): boolean {
    // Define the base URL
    let url = 'https://refundedcosts.neworg.net/';

    // Check if the widget URL is present and not empty
    if (!widgetUrl || widgetUrl.trim().length === 0)
      return false;

    // Define an object that maps the conditions to the URLs and class names
    const routeMap = {
      'refundedcostsApp': {
        link: ['app', `${url}`],
        class: apps.refundedCosts
      },
    };

    const route = routeMap[widgetUrl];
    // Check if a route is defined for the widget URL
    if (!route)
      return false;

    // Set the class name and navigate to the URL
    this.stateHolder.setRefundedCostsNavbarClass();

    this._router.navigate(route.link);
    return true;
  }

  dragStart(smartButton: any) {
    this.draggedButton = smartButton;
  }

  dragEnd() {
    this.draggedButton = undefined;
  }

  drop() {
    this._debugLogger.logAction('SmartBox', 'button added', { name: this.draggedButton?.name });
    let index = this.smartButtons.indexOf(this.draggedButton)
    this.smartButtons.splice(index, 1)

    this.selectedSmartButtons.push(this.draggedButton)
    this.mapSmartButtons();
    this.mapSmartButtonView();

    this.draggedButton = undefined;
  }

  showButtonParams(smartButton: any) {
    this.selectedIcon = this.icons.find(i => { return i.iconClass === smartButton.buttonIcon })

    if (!this.selectedIcon)
      this.selectedIcon = {
        iconClass: 'sub_icon primeNG pi pi-plus-circle',
        name: 'Nuovo'
      };

    this.selectedButtonToEdit = smartButton;
  }

  moveSmartButtonStart(smartButton: any) {
    this.draggedMovedButton = smartButton;
    this.showButtonBin = true;
  }

  moveSmartButtonEnd() {
    this.draggedMovedButton = undefined;
    this.showButtonBin = false;
  }

  moveButton(newIndex: any) {
    this.showButtonBin = false;
    const fromIndex = this.selectedSmartButtons.indexOf(this.draggedMovedButton);
    const element = this.selectedSmartButtons.splice(fromIndex, 1)[0];
    this.selectedSmartButtons.splice(newIndex, 0, element);
  }

  removeButton() {
    this._debugLogger.logAction('SmartBox', 'button removed', { name: this.draggedMovedButton?.name });
    this.showButtonBin = false;
    this.selectedButtonToEdit = undefined;

    let index = this.selectedSmartButtons.indexOf(this.draggedMovedButton);
    this.selectedSmartButtons.splice(index, 1)
    this.mapSmartButtons();
    this.mapSmartButtonView();
  }

  getCustomDialogButton() {
    return new SmartButtonModel(
      {
        name: 'Custom Dialog',
        functionName: 'Richiesta dialogo',
        refAppId: 'e0b363fe-0ebb-4740-88c1-c46001ccab21',
        buttonClass: 'tile tile-sm tile-red',
        backgroundColor: '#ea5046',
        buttonIcon: 'sub_icon primeNG pi pi-plus-circle',
        custom: true,
        version: 2,
        params: {
          idRequestTypology: ''
        }
      })
  }

  getCustomLinkButton() {
    return new SmartButtonModel(
      {
        name: 'Custom link',
        functionName: 'Custom link',
        refAppId: '',
        buttonClass: 'tile tile-sm tile-orange',
        backgroundColor: '#f19124',
        buttonIcon: 'sub_icon primeNG pi pi-at',
        custom: true,
        version: 2,
      })
  }

  // emit the index of the smart box that was
  // clicked on to the parent component
  editSmartBox() {
    this.boxIndex.emit(this.idx)
    this.showEditModal = true;
  }

  // emit the updated list of selected smart buttons
  //to the parent component and close the modal
  confirmEdit() {
    this._debugLogger.logEvent('SmartBox', 'dashboardParams emitted', { buttons: this.selectedSmartButtons?.length });
    this.dashboardParams.emit(this.selectedSmartButtons)
    this.disableEditMode.emit(true);
    this.showEditModal = false;
  }

  // close the modal without saving changes a
  //and emit the original list of smart buttons
  closeModal() {
    this.mapWidgetParams();
    this.disableEditMode.emit(true);
    this.showEditModal = false;
  }
}

export class SmartButtonModel {
  name = '';
  viewName = '';
  tooltip = '';
  refAppId = '';
  buttonClass = '';
  buttonIcon = '';
  url = '';
  custom = false;
  backgroundColor = '';
  params = {};
  version = 1;
  buttonStyle = '';

  constructor(model: any) {
    this.name = model.name || '';
    this.viewName = model.viewName || model.functionName || '';
    this.tooltip = model.tooltip || model.functionName || '';
    this.refAppId = model.refAppId || model.id || '';
    this.custom = model.custom != null || model.custom != undefined ? model.custom : false;
    this.backgroundColor = model.backgroundColor || '';
    this.params = model.params || {};
    this.url = model.url || '';
    this.version = model.version || 1;

    if (!this.custom) {
      this.url = '';
      this.version = 2;
    }
    this.buttonClass = model.mainClass || model.buttonClass || '';

    if (!this.buttonClass.includes('scalein animation-duration-500'))
      this.buttonClass = this.buttonClass + ' ' + 'scalein animation-duration-500';

    if (!this.buttonClass.includes('animatedBox'))
      this.buttonClass = this.buttonClass + ' ' + 'animatedBox';

    this.buttonIcon = model.iConClass || model.buttonIcon || '';
    if (this.version === 1) {
      switch (model.name) {
        case 'CDialog':
          this.name = 'Custom Dialog';
          this.version = 2;
          this.url = '';
          this.params = {
            idRequestTypology: model.url
          }
          break;
        default:
          this.version = 2;
          break;
      }
      if (model.id && model.id.trim().length > 0) {
        this.url = '';
      } else {
        this.name = model.functionName
      }
    }
    //Per la gestione delle icone PrimeNG
    this.buttonStyle = this.buttonIcon && this.buttonIcon.includes('pi pi-') ? 'margin-top: 8px !important;font-size: 1.7rem !important; padding-right: 0; padding-top: 0; float: none;' : 'padding-right: 0; padding-top: 0; float: none;';
  }
}

